<template>
  <div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div
          id="kt_content_container"
          class="container"
          style="
          margin-top: 10px;
          max-width: 100%;
          flex-direction: row !important;
          display: flex;
        "
      >
        <!-- 搜索开始 -->
        <div
            class="flex-column flex-lg-row-auto w-100 w-lg-250px w-xxl-325px mb-8 mb-lg-0 me-lg-9 me-5"
        >
          <form action="#" id="category_form1">
            <div class="card">
              <div class="card-body" style="padding: 1.2rem 1rem">
                <div class="mb-5">
                  <div class="nav-group nav-group-fluid">
                    <label>
                      <input
                          type="radio"
                          class="btn-check"
                          name="goodsPlace"
                          @click="changIsShow()"
                          value="0"
                          :checked="!this.params.isShow"
                      />
                      <span
                          class="btn btn-sm btn-color-muted btn-active btn-active-primary fw-bolder px-4"
                      >
                        全部资讯
                      </span>
                    </label>
                    <label>
                      <input
                          type="radio"
                          class="btn-check"
                          name="goodsPlace"
                          @click="changIsShow(1)"
                          value="1"
                      />
                      <span
                          class="btn btn-sm btn-color-muted btn-active btn-active-primary fw-bolder px-4"
                      >
                        上架资讯
                      </span>
                    </label>
                    <label>
                      <input
                          type="radio"
                          class="btn-check"
                          name="goodsPlace"
                          @click="changIsShow(2)"
                          value="2"
                      />
                      <span
                          class="btn btn-sm btn-color-muted btn-active btn-active-primary fw-bolder px-4"
                      >
                        下架资讯
                      </span>
                    </label>
                  </div>
                </div>
                <div class="separator separator-dashed my-8"></div>
                <div class="mb-5">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >资讯标题</label
                  >
                  <div class="position-relative">
                    <span
                        class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                    >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                      >
                        <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                              d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                              opacity="0.3"
                          ></path>
                          <path
                              d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                              fill="#000000"
                              fill-rule="nonzero"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    <input
                        id="title"
                        type="text"
                        class="form-control form-control-solid ps-10"
                        name="search"
                        v-model="params.title"
                        value=""
                        placeholder="请输入需要查询的资讯标题"
                    />
                  </div>
                </div>
<!--                <div class="mb-5">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >一级分类</label
                  >
                  <select
                      class="form-select form-select-solid"
                      v-model="params.categoryId1"
                      data-placeholder="全部"
                      @change="findCategory(1)"
                  >
                    <option value="">全部</option>
                    <option
                        v-for="(item, index) in categoryOne"
                        :key="index"
                        :value="item.categoryId"
                    >
                      {{ item.fullName }}
                    </option>
                  </select>
                </div>-->

<!--                <div class="mb-5">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >二级分类</label
                  >
                  <select
                      class="form-select form-select-solid"
                      v-model="params.categoryId2"
                      @change="findCategory(2)"
                      data-placeholder="全部"
                  >
                    <option value="">全部</option>
                    <option
                        v-for="(item, index) in categoryTwo"
                        :key="index"
                        :value="item.categoryId"
                    >
                      {{ item.fullName }}
                    </option>
                  </select>
                </div>-->


                <div class="mb-5">
                  <label class="fs-6 form-label fw-bolder text-dark">资讯分类</label>
                  <select class="form-select form-select-solid" v-model="params.isType" data-placeholder="全部">
                    <option value="">全部</option>
                    <option value="1">图文</option>
                    <option value="2">视频</option>
                  </select>
                </div>

<!--                <div class="mb-5">
                  <label class="fs-6 form-label fw-bolder text-dark">发货时效</label>
                  <el-checkbox-group v-model="deliveryTime">
                    <el-checkbox label="24小时内发货"></el-checkbox>
                    <el-checkbox label="48小时内发货"></el-checkbox>
                    <el-checkbox label="48小时内发货(周末、节假日除外)"></el-checkbox>
                    <el-checkbox label="72小时内发货"></el-checkbox>
                    <el-checkbox label="其他"></el-checkbox>
                  </el-checkbox-group>
                </div>-->

<!--                <div class="mb-5">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >库存区间</label
                  >
                  <div class="row">
                    <div class="col-lg-6 fv-row fv-plugins-icon-container">
                      <input
                          type="text"
                          id="minStock"
                          name="minStock"
                          class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                          v-model="params.minStock"
                          oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
                          placeholder="最小值"
                          value=""
                      />
                      <div
                          class="fv-plugins-message-container invalid-feedback"
                      ></div>
                    </div>

                    <div class="col-lg-6 fv-row fv-plugins-icon-container">
                      <input
                          type="text"
                          id="maxStock"
                          name="maxStock"
                          class="form-control form-control-lg form-control-solid"
                          v-model="params.maxStock"
                          oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
                          placeholder="最大值"
                          value=""
                      />
                      <div
                          class="fv-plugins-message-container invalid-feedback"
                      ></div>
                    </div>
                  </div>
                </div>-->


                <div class="d-flex align-items-center justify-content-end">
                  <a
                      @click="shaixuan"
                      href="javascript:void(0);"
                      class="btn btn-primary"
                  >筛选</a
                  >&nbsp;&nbsp;&nbsp;
                  <!--btn-active-light-primary 点击变色-->
                  <a
                      @click="resetQuery();"
                      href="javascript:void(0);"
                      class="btn text-hover-primary bg-hover-light  btn-color-gray-400 me-3"
                  >重置</a
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- 列表开始 -->
        <div
            class="card mb-5 mb-xl-8"
            style="margin-left: 3px; width: 100%"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            v-loading="loading"
        >
          <div class="card-body py-3" style="padding-left: 15px">
            <div class="table-responsive">
              <table
                  class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
                  id="kt_ecommerce_products_table"
              >
                <thead>
                <tr
                    class="text-start text-gray-500 fs-7 text-uppercase gs-0"
                >
<!--                  <th
                      class="w-10px pe-2 sorting_disabled"
                      rowspan="1"
                      colspan="1"
                      aria-label=""
                      style="max-width: 30px"
                  >
                    <div
                        class="form-check form-check-sm form-check-custom form-check-solid me-3"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          data-kt-check="true"
                          data-kt-check-target="#kt_ecommerce_products_table .form-check-input"
                          value="TRUE"
                          v-model="checkboxInput"
                          @change="checkboxInputEvent"
                      />
                    </div>
                  </th>-->
                  <th
                      class=" text-center min-w-50px"
                      tabindex="0"
                      aria-controls="kt_ecommerce_products_table"
                      rowspan="1"
                      colspan="1"
                      aria-label="Product: activate to sort column ascending"
                      style="width: 7%"
                  >
                    id
                  </th>
                  <th
                      class="min-w-300px"
                      tabindex="0"
                      aria-controls="kt_ecommerce_products_table"
                      rowspan="1"
                      colspan="1"
                      aria-label="Product: activate to sort column ascending"
                      style="width: 17%"
                  >
                    资讯信息
                  </th>
                  <th
                      class="text-center min-w-150px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="积分"
                      :style="{ 'width':'6%'  }"
                  >
                    积分
                  </th>
                  <th
                      class="text-center min-w-150px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="线路分类"
                      :style="{ 'width':'6%'}"
                  >
                    资讯分类
                  </th>
<!--                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="市场价"
                      :style="{ 'width': role.includes('firstGradeSupplier') || role.includes('vipMember') ? '5%' : '7%' }"
                  >
                    市场价
                  </th>
                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="定金"
                      :style="{ 'width': role.includes('firstGradeSupplier') || role.includes('vipMember') ? '4%' : '6%' }"
                  >
                    定金
                  </th>
                  <th
                      class="text-center min-w-100px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="排序"
                      :style="{ 'width': role.includes('firstGradeSupplier') || role.includes('vipMember') ? '5%' : '7%' }"
                  >
                    排序
                  </th>-->
                  <th
                      class="text-center min-w-150px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="状态"
                      style="width: 5%"
                  >
                    状态
                  </th>
                  <th
                      class="text-center min-w-150px"
                      tabindex="0"
                      rowspan="1"
                      colspan="1"
                      aria-label="更新时间"
                      style="width: 8%"
                  >
                    创建时间
                  </th>
                  <th
                      class="text-center max-w-70px sorting_disabled"
                      rowspan="1"
                      colspan="1"
                      aria-label="操作"
                      style="width: 10%"
                  >
                    操作
                  </th>
                </tr>
                </thead>
                <tbody class="fw-semibold text-gray-600">
                <tr
                    v-for="(item, index) in rows"
                    :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
                    :key="index"
                >
                  <!-- 复选按钮 -->
<!--                  <td>
                    <div
                        class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          value="1"
                          @click="addIdArr(item.id)"
                          :checked="idArr.includes(item.id)"
                      />
                    </div>
                  </td>-->
                  <!-- 分类 -->
                  <td class="text-center pe-0">
                    <div
                        style="font-size: 90%"
                        v-html="item.id"
                    ></div>
                  </td>
                  <!-- 商品信息 -->
                  <td style="padding-right: 0">
                    <div
                        class="d-flex align-items-center"
                    >
                      <a href="javascript:void(0)" class="symbol symbol-50px">
                        <img
                            class="symbol-label lozad"
                            v-if="item.picUrl.indexOf('http') == 0"
                            :src="`${item.picUrl}`"
                        />
                        <img
                            class="symbol-label lozad"
                            v-else
                            :src="`https://www.3jzc.cn${item.picUrl}`"
                        />
                      </a>
                      <div
                          style="
                            max-width: 170px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            margin-left: 10px;
                          "
                      >
                        <a
                            href="javascript:void(0)"
                            :title="item.title"
                            class="text-gray-800 text-hover-primary fs-5"
                            data-kt-ecommerce-product-filter="product_name"
                        >{{ item.title }}</a
                        >
                      </div>
                    </div>
                  </td>
                  <!-- 积分 -->
                  <td class="text-center pe-0">
                    <span>{{ item.score }}</span>
                  </td>
                  <!-- 分类 -->
                  <td class="text-center pe-0">
                    <div
                        style="font-size: 90%"
                        v-if="item.isType == 1"
                    >图文</div>
                    <div
                        style="font-size: 90%"
                        v-if="item.isType == 2"
                    >视频</div>
                  <!-- 状态 -->
                  <td class="text-center pe-0">
                      <span
                          class="text-center"
                          v-if="item.isShow.indexOf('已上架') >= 0"
                      >
                        <span
                            class="badge badge-light-success fs-7"
                            style="
                            display: block;
                            text-align: center;
                            margin: 0 auto;
                          "
                            v-html="sArr(item.isShow)[0]"
                        ></span>
                      </span>
                    <span
                        class="badge badge-light-danger fs-7"
                        v-else
                        style="display: block; text-align: center; width: 80px"
                        v-html="item.isShow"
                    ></span>
                  </td>

                  <!-- 更新时间 -->
                  <td class="text-center pe-0">
                    <span>{{ item.crTime }}</span>
                  </td>
                  <!-- 操作 -->
                  <td class="text-center">
                    <a
                        href="#"
                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-end"
                        @click="toggleDropdown(index)"
                    >
                      操作
                      <i class="ki-outline ki-down fs-5 ms-1"></i>
                    </a>
                    <div
                        :id="'dropdown-' + index"
                        class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-150px py-4"
                        data-kt-menu="true"
                    >


                      <div
                          class="menu-item px-3"
                          v-if="item.isShow.indexOf('已上架') == -1"
                      >
                        <a
                            href="javascript:void(0)"
                            class="menu-link px-3"
                            @click="updateIsShow(item, 1)"
                        >上架</a
                        >
                      </div>
                      <div class="menu-item px-3" v-else>
                        <a
                            href="javascript:void(0)"
                            class="menu-link px-3"
                            @click="updateIsShow(item, 2)"
                        >下架</a
                        >
                      </div>
                      <div class="menu-item px-3">
                        <a
                            href="javascript:void(0)"
                            class="menu-link px-3"
                            @click="updateIsShow(item, 3)"
                        >删除</a
                        >
                      </div>
                      <div class="menu-item px-3">
                        <a
                            href="javascript:void(0)"
                            class="menu-link px-3"
                            @click="
                              $router.push({
                                name: 'AddOrUpdateArticle',
                                params: { id: item.id },
                              })
                            "
                        >编辑</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <Pagination
                  :total-items="totalCount"
                  @page-change="pageChange"
                  ref="Pagination"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  弹窗 -->
    <!-- 商品详情 -->
    <ModalDialog title="线路详情" id="goodInfo" ref="goodInfo" width="1000px">
      <TravelInfoComponent ref="travelInfoComponent"></TravelInfoComponent>
    </ModalDialog>
    <!-- 修改市场价 -->
    <ModalDialog
        title="修改市场价"
        id="editPriceModalDialog"
        ref="editPriceModalDialog"
        width="500px"
    >
      <span class="d-inline-block">市场价</span>
      <el-input
          class="ms-5 d-inline-block w-50"
          v-model="editObj.price"
      ></el-input>
      <span
          class="mt-2 d-block dialog-footer justify-content-center align-items-center"
      >
        <el-button @click="openEditPriceDialog(0)">取 消</el-button>
        <el-button type="primary" @click="editPrice()">确 定</el-button>
      </span>
    </ModalDialog>

    <ModalDialog
        title="修改定金"
        id="editDepositModalDialog"
        ref="editDepositModalDialog"
        width="500px"
    >
      <span class="d-inline-block">定金</span>
      <el-input
          class="ms-5 d-inline-block w-50"
          v-model="editObj.deposit"
      ></el-input>
      <span
          class="mt-2 d-block dialog-footer justify-content-center align-items-center"
      >
        <el-button @click="openEditDepositDialog(0)">取 消</el-button>
        <el-button type="primary" @click="editDeposit()">确 定</el-button>
      </span>
    </ModalDialog>

    <ModalDialog
        title="修改排序"
        id="editSortNumModalDialog"
        ref="editSortNumModalDialog"
        width="500px"
    >
      <span class="d-inline-block">排序</span>
      <el-input
          class="ms-5 d-inline-block w-50"
          v-model="editObj.sortNum"
      ></el-input>
      <span
          class="mt-2 d-block dialog-footer justify-content-center align-items-center"
      >
        <el-button @click="openEditSortNumDialog(0)">取 消</el-button>
        <el-button type="primary" @click="editSortNum()">确 定</el-button>
      </span>
    </ModalDialog>




  </div>
</template>
<script>

// 导入数据api
import {
  getExportTravelListApi,
  getTravelListApi,
  getSjGoodsListBySpuIdApi,
  updateIsShowApi,
  updateTravelPriceApi,
  updateTravelDepositApi,
  getTravelListCountApi,
  updateTravelSortNumApi
} from "@/api/articleManageApi";
import TravelInfoComponent from "@/components/TravelInfoComponent";
// 页码指定跳转
import Pagination from "@/components/Pagination/index.vue";
import sd from "silly-datetime";

export default {
  components: {
    Pagination,
    TravelInfoComponent,
  },
  data() {
    return {
      dialogTableVisible: false,
      staffArr: [],
      categoryOne: [],
      categoryTwo: [],
      idArr: [],
      checkboxInput: false,
      rows: [],
      loading: false,
      params: {
        current: 1,
        size: 10,
        title: "",
        isShow: "",
        isType:"",
      },
      deliveryTime: [],
      poolSupplPrice: "",
      totalCount: 999,
      first: true,
      editObj: {
        ids: [],
        price: "",
        deposit: "",
        sortNum: "",
        isShow: 2,
      },
      editStockObj: {
        ids: [],
        stock: 0,
      },
      spuIdList: [],
      role: []
    };
  },
  computed: {
    zzxwRatio() {
      return this.toFixedCeil(
          this.editObj.supplPrice / (1 - this.editObj.ratio * 0.01),
          2
      );
    },
  },
  // 方法
  methods: {
    reloadIdArr() {
      this.idArr = [];
      this.$emit("setArrId", this.idArr)
    },
    setArrId() {
      this.$emit("setArrId", this.idArr)
    },
    sArr(text) {
      return text.split("<br>")
    },
    //重置
    resetQuery() {
      this.deliveryTime = [];
      this.params = {
        current: 1,
        size: 10,
        title: "",
        isShow: this.params.isShow,
        isType:"",
      }
      this.first = true
      this.getTravelList()
    },
    checkboxInputEvent() {
      if (this.checkboxInput) {
        this.rows.forEach((e) => {
          if (!this.idArr.includes(e.id)) {
            this.idArr.push(e.id);
          }
        });
      } else {
        this.rows.forEach((e) => {
          let index = this.idArr.indexOf(e.id);
          if (index !== -1) {
            this.idArr.splice(index, 1);
          }
        });
      }
      this.setArrId()
    },
    async addIdArr(id) {
      if (this.idArr.includes(id)) {
        let index = this.idArr.indexOf(id);
        if (index !== -1) {
          this.idArr.splice(index, 1);
        }
      } else {
        this.idArr.push(id);
      }
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArr.includes(e.id)) {
          a = false;
        }
      });
      this.checkboxInput = a;
      this.setArrId()

    },
    async checkGoods(spuId) {
      let {data} = await getSjGoodsListBySpuIdApi({
        spuId,
      });
      this.spuIdList = data.rows;
      this.dialogTableVisible = true;
    },
    // 修改状态
    async updateIsShow(item,isShow) {
      let msg = isShow == 1 ? "上架" : isShow == 2 ? "下架" : isShow == 3 ? "删除" : "未知状态";
      this.$confirm(`你确定${msg}该商学院 `, `是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      }).then(async () => {
        await updateIsShowApi(
            JSON.stringify({
              ids: [item.id],
              isShow: isShow,
            })
        );
        this.$message({
          type: "success",
          message: msg + "成功!",
        });
        this.getTravelList();
      }).catch(() => {
      });
    },

    // 打开弹窗并修改市场价
    openEditPriceDialog(item) {
      if (item) {
        this.$refs.editPriceModalDialog.open();
        this.editObj.ids = Array.from([item.id]);
        this.editObj.price = item.price;
      } else {
        this.$refs.editPriceModalDialog.close();
        this.editObj = {
          ids: [],
          price: "",
          deposit: "",
          sortNum: "",
          isShow: 2,
        };
      }
    },


    // 打开弹窗并修改定金
    openEditDepositDialog(item) {
      if (item) {
        this.$refs.editDepositModalDialog.open();
        this.editObj.ids = Array.from([item.id]);
        this.editObj.deposit = item.deposit;
      } else {
        this.$refs.editDepositModalDialog.close();
        this.editObj = {
          ids: [],
          price: "",
          deposit: "",
          sortNum: "",
          isShow: 2,
        };
      }
    },
    //修改市场价
    async editPrice() {
      await updateTravelPriceApi(JSON.stringify(this.editObj));
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.$refs.editPriceModalDialog.close();
      this.getTravelList();
      this.editObj = {
        ids: [],
        price: "",
        deposit: "",
        sortNum: "",
        isShow: 2,
      };
    },

    //修改定金
    async editDeposit(item) {
      await updateTravelDepositApi(JSON.stringify(this.editObj));
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.$refs.editDepositModalDialog.close();
      this.getTravelList();
      this.editObj = {
        ids: [],
        price: "",
        deposit: "",
        sortNum: "",
        isShow: 2,
      };
    },


    // 打开弹窗并修改排序
    openEditSortNumDialog(item) {
      if (item) {
        this.$refs.editSortNumModalDialog.open();
        this.editObj.ids = Array.from([item.id]);
        this.editObj.sortNum = item.sortNum;
      } else {
        this.$refs.editSortNumModalDialog.close();
        this.editObj = {
          ids: [],
          price: "",
          deposit: "",
          sortNum: "",
          isShow: 2,
        };
      }
    },


    //修改排序
    async editSortNum(item) {
      await updateTravelSortNumApi(JSON.stringify(this.editObj));
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.$refs.editSortNumModalDialog.close();
      this.getTravelList();
      this.editObj = {
        ids: [],
        price: "",
        deposit: "",
        sortNum: "",
        isShow: 2,
      };
    },

    checkPay(){
      if (localStorage.getItem('paying')){
        this.$confirm('是否完成支付?', '支付', {
          confirmButtonText: '已经完成',
          cancelButtonText: '未完成',
          type: 'warning'
        }).then(() => {
          this.checkOrder();
          localStorage.removeItem("paying")
        }).catch(() => {
          this.checkOrder();
          localStorage.removeItem("paying")
        });
      }
    },
    checkOrder(){
      console.log(1)
    },
    pay(){
      this.$refs.VipPayComponent.openPay({
        type: 4,
        rerunUrl: process.env.NODE_ENV === "development"?"http://localhost:8080/#/payCallback":"https://saas.zhelidao.com/#/payCallback"
      })
    },
    toFixedCeil(num, decimal) {
      return (
          Math.ceil(num * Math.pow(10, decimal)) / Math.pow(10, decimal)
      ).toFixed(decimal);
    },

    // 打开商品信息
    openGoodInfo(id) {
      this.$refs.goodInfo.open();
      this.$refs.travelInfoComponent.openTravelInfo(id);
    },
    // 导出商品数据到excel
    async exp() {
      let obj = this.params;
      obj.current = null;
      obj.size = null;
      let data = await getExportTravelListApi(obj);
      var blob = new Blob([data], {type: "application/octet-stream"});
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;

      a.download = `旅游线路信息-${sd.format(new Date(), "YYYY-MM-DD")}.xls`; // 设置下载的文件名，根据需要修改
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    // 导出数据到ppt
    async exportPPT() {

    },
    // 传递id
    editEvent(id) {
      this.$emit("editEvent", id);
    },
    // 分页查询
    async getTravelList() {
      if (this.deliveryTime.length > 0) {
        this.params.deliveryTime = this.deliveryTime.join(',');
      } else {
        this.params.deliveryTime = "";
      }
      if (this.role.includes('firstGradeSupplier')){
        this.params.isTwoShow = 1
      }
      this.checkboxInput = false;
      this.loading = true;
      let {data} = await getTravelListApi(this.params);
      this.loading = false;
      this.rows = data.rows;
      if (this.first) {
        this.getTravelPageCount();
      }

      this.first = false;
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArr.includes(e.id)) {
          a = false;
        }
      });
      this.checkboxInput = a;
      this.setArrId()
    },
    // 分页
    pageChange(currentPage, pageSize) {
      this.params.current = currentPage;
      this.params.size = pageSize;

      this.getTravelList();
    },
    // 求和
    async getTravelPageCount() {
      let {data} = await getTravelListCountApi(this.params);
      this.totalCount = data;
    },
    toggleDropdown(index) {
      this.$nextTick(() => {
        const dropdown = document.getElementById(`dropdown-${index}`);
        new KTMenu(dropdown);
      });
    },
    // 自有商品上下架切换
    changIsShow(index) {
      this.idArr = []
      this.first = true;

      if (index) {
        this.params.isShow = index;
        this.params.isTwoShow = 1;
      }
      if (!index){
        this.params.isShow = "";
        this.params.isTwoShow = "";
      }
      this.getTravelList();
    },
    // 筛选
    shaixuan() {
      this.idArr = []
      this.first = true;
      if (this.params.current != 1) {
        this.$refs.Pagination.goToPage(1);
      } else {
        this.getTravelList();
      }
    },


    // 获取角色权限
    getLoginRole() {
      this.role = localStorage.getItem('role')
    }
  },
  // 父类index使用
  createGoods() {
  },
  // 初始化这个方法
  created() {
    this.getLoginRole();
    this.getTravelList();
   // this.initCategory();
  },
  updated() {
    // 当数据更新后，可以在此处手动初始化下拉菜单插件
    this.rows.forEach((_, index) => {
      this.toggleDropdown(index);
    });
  },
};
</script>
<!--组件样式-->
<style scoped>
.borderHover:hover {
  border-color: rgb(0, 158, 247) !important;
}

/* 修改滚动条样式 */
.table-responsive::-webkit-scrollbar {
  width: 20px; /* 设置滚动条宽度 */
  height: 15px;
  background-color: #F5F5F5; /* 设置滚动条背景颜色 */
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #888; /* 设置滚动条滑块颜色 */
  border-radius: 5px; /* 设F置滚动条滑块圆角 */
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 设置滚动条滑块在鼠标悬停时的颜色 */
}
</style>
